<template>
  <div id="productList">
    <div class="newlistCenter">
      <div class="ulCenter">
        <ul class="ul_Two">
          <li
            class="Lishow"
            :class="{ active: index == curId }"
            v-for="(item, index) in columname"
            :key="item.id"
            @click="INDEX(index)"
          >
            {{ item.columname }}
          </li>
        </ul>
      </div>
      <!-- 移动端标签 -->
      <div class="phCenter">
        <van-tabs @click="onClick">
          <van-tab v-for="(item) in columname" :title="item.columname" :key="item.id">
            
          </van-tab>
        </van-tabs>
      </div>
      <div
        class="dis"
        v-for="(i, index) in columname"
        :key="i.id"
        v-show="index == curId"
      >
        <div
          class="imgList"
          data-wow-duration="1.5s"
          data-wow-delay=".5"
          data-wow-offset="0"
          v-for="item in ProductList"
          :key="item.id"
          @click="goDetail(item.id,8)"
        >
          <div class="imgitem">
            <img v-lazy="item.images" alt="" />
          </div>
          <p class="p1">
            <a>{{item.columname}}</a>
            
            <!-- <router-link
              tag="a"
              :to="{ path: 'special', query: { id: item.id, modular: 8 } }"
              :title="item.columname"
            >
              {{ item.columname }}</router-link
            > -->
          </p>
          <p class="p2" >
            <span v-html="item.brief"></span>
            <!-- <router-link
              :to="{ path: 'special', query: { id: item.id, modular: 8 } }"
              tag="a"
              :title="item.brief"
              v-html="item.brief"
            >
            </router-link> -->
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import { WOW } from "wowjs";
import router from "../../router/index";
import { GetHomePage_Two, getFooter } from "@/https/http";
import { Tab, Tabs } from 'vant';

Vue.use(Tab);
Vue.use(Tabs);
export default {
  components:{
    [Tab.name]:Tab,
    [Tabs.name]:Tabs,
  },
  data() {
    return {
      NewsList: "",
      num: "",
      NewList: "",
      productListNav: "",
      curId: 0,
      ProductList: "",
      columname: "",
      arr: [],
      column: "",
      Li: [1],
      Quanbuchanpin: { columname: "全部产品" },
      QQQuanbu: "",
      QuanBu: [],
    };
  },
  beforecreate() {
    // GetHomePage_Two({ column_id: this.arr[0].id }).then((res) => {
    //   this.columname = res.result.data;
    //   GetHomePage_Two({ column_id: this.columname[this.curId].id }).then(
    //     (res) => {
    //       this.ProductList = res.result.data;
    //     }
    //   );
    // });
  },
  methods: {
    onClick(name, title) {
      this.curId = name;
      console.log(title,name);
      GetHomePage_Two({ column_id: this.columname[this.curId].id }).then(
        (res) => {
          this.ProductList = res.result.data;
        }
      );
      if (name == 0) {
        GetHomePage_Two({ column_id: this.arr[this.curId].id }).then((res) => {
          this.QQQuanbu = res.result.data;
          let arr = [];
          this.QQQuanbu.forEach(function (item) {
            GetHomePage_Two({ column_id: item.id }).then((res) => {
              res.result.data.forEach(function (item) {
                arr.push(item);
              });
            });
          });
          this.ProductList = arr;
        });
      }
    },
    INDEX(x) {
      this.curId = x;
      GetHomePage_Two({ column_id: this.columname[this.curId].id }).then(
        (res) => {
          this.ProductList = res.result.data;
        }
      );
      if (x == 0) {
        GetHomePage_Two({ column_id: this.arr[this.curId].id }).then((res) => {
          this.QQQuanbu = res.result.data;
          let arr = [];
          this.QQQuanbu.forEach(function (item) {
            GetHomePage_Two({ column_id: item.id }).then((res) => {
              res.result.data.forEach(function (item) {
                arr.push(item);
              });
            });
          });
          this.ProductList = arr;
        });
      }
    },
    goDetail(id,modular){
      // id: item.id, modular: 8
      let routerData = this.$router.resolve({
        path:'/special',
        query: { id: id, modular: modular}

      })
      window.open(routerData.href,'_blank')

    }
  },
  created() {
    getFooter({ type: "1" }).then((res) => {
      res.result.data.forEach((item) => {
        if (item.modular === "8") {
          this.column = item;
          this.arr.push(item);
        }
      });
      GetHomePage_Two({ column_id: this.arr[this.curId].id }).then((res) => {
        this.columname = res.result.data;
        this.columname.unshift(this.Quanbuchanpin);
        console.log(this.columname, "this.ProductList");
        this.curId = this.$route.query.index
          ? Number(this.$route.query.index) + 1
          : 0;
        GetHomePage_Two({ column_id: this.columname[this.curId].id }).then(
          (res) => {
            this.ProductList = res.result.data;
          }
        );
      });
      GetHomePage_Two({ column_id: this.arr[this.curId].id }).then((res) => {
        this.QQQuanbu = res.result.data;
        let arr = [];
        this.QQQuanbu.forEach(function (item) {
          GetHomePage_Two({ column_id: item.id }).then((res) => {
            res.result.data.forEach(function (item) {
              arr.push(item);
            });
          });
        });
        this.ProductList = arr;
      });
    });
  },
  beforeDestroy() {
    this.$EventBus.$off("eventBusName");
  },

  mounted() {
    // this.$EventBus.$on("eventBusName", (msg) => {
    //   this.curId = msg;
    //   console.log(msg);

    //   GetHomePage_Two({ column_id: this.columname[this.curId].id }).then(
    //     (res) => {
    //       this.ProductList = res.result.data;
    //       console.log("this.productList", this.ProductList);
    //     }
    //   );
    // });

    window.addEventListener("scroll", this.windowScroll);
    this.$parent.color = `#000`;
    this.$parent.backgroundColor = "#fff";
    let wow = new WOW({
      boxClass: "wow", //需要执行动画的元素的 class
      animateClass: "animated", //animation.css 动画的 class
      offset: 0, //距离可视区域多少开始执行动画
      mobile: true, //是否在移动设备上执行动画
      live: true, //异步加载的内容是否有效
    });
    wow.init();
    router.afterEach((to, from, next) => {
      window.scrollTo(0, 0);
      console.log(to, from, next);
    });
  },
};
</script>
<style lang="scss" scoped>
ul {
  list-style: none;
}
@media screen and(min-width: 1020px){
  .phCenter{
    display: none;
  }
  .ulCenter {
  width: 1440px;
  min-width: 1440px;
  margin: 20px auto;
}
.ul_Two {
  display: flex;
  float: right;
  margin-left: 1142px;
  height: 16px;
  li.active {
    color: #ff8229;
  }
  li :hover {
    color: #ff8229;
  }

  li.active {
    color: #ff8229;
  }
  li {
    width: 64px;
    height: 16px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    line-height: 30px;
    margin-left: 63px;
    cursor: pointer;
  }
}
.imgList:hover {
  margin-bottom: -4px;
  border-bottom: 4px solid #ff6c04;
  .p1:hover {
    color: #ff6c04;
  }
}

#productList {
  width: 100%;
  .newlistCenter {
    width: 1440px;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 50px;
    .dis {
      display: flex;
      flex-wrap: wrap;
      align-content: center;
    }
    .imgList {
      width: 347px;
      height: 479px;
      margin-left: 13px;
      margin-top: 31px;
      position: relative;
      cursor: pointer;
      img {
        width: 350px;
        height: 292px;
      }
      .p1 {
        width: 301px;
        height: 24px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        margin-left: 21px;
      }
      .p1 > a {
        width: 301px;
        height: 18px;
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        line-height: 30px;
        text-decoration: none;
      }
      .p1 > a:hover {
        color: #ff6c04;
        cursor: pointer;
      }
      .p2 {
        width: 306px;
        margin-left: 21px;
        /* -----------------------------文字换行----------------------------- */
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .p2 > span {
        width: 306px;
        height: 47px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
        line-height: 30px;
        cursor: pointer;
        text-decoration: none;
      }
      .Time {
        width: 89px;
        margin-left: 21px;
        height: 14px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
        line-height: 23px;
        cursor: pointer;
      }
    }
  }
}
.F {
  height: 34px;
  min-width: 1440px;
  margin-bottom: 148px;
  .F1Center {
    width: 1440px;
    min-width: 1440px;
    height: 34px;
    margin: 0 auto;
    .F1 {
      width: 34px;
      height: 34px;
      background: #ff8229;
      border-radius: 5px;
      p {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        line-height: 30px;
        text-align: center;
      }
    }
  }
}
}
@media screen and(max-width:1020px){
  #productList{
    width: 100%;

    .newlistCenter{
      width: 100%;

      .ulCenter{
        display: none;
      }
      .phCenter{
        width: 100%;
        height:70px;
        .van-tabs__wrap{
          display: flex;
        }
        .van-tabs__nav{
          display: flex;
        }
      }
      .dis{
        width: 100%;
        padding-left:10px;
        padding-right:10px;
        box-sizing: border-box;
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
        justify-content: space-between;
        .imgList{
          width: 49%;
          overflow: hidden;
          height:250px;
          margin-bottom:10px;
          
          .imgitem{
            width: 100%;
            height:130px;
            overflow: hidden;
            img{
              width: 100%;
            }
          }
          .p1{
            
            width: 100%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            margin:0;
            margin-top:15px;
          }
          .p1 > a{
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
            line-height: 20px;
            text-decoration: none;
          }
          .p2{
            margin:0;
            margin-top:-10px;
            width:100%;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }
          .p2 > span{
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #999999;
            line-height: 30px;
            cursor: pointer;
            text-decoration: none;
          }
        }
      }
    }
  }
}


</style>